import product from './product';

function Name() {
  return <h2 className="product-name">{product.name}</h2>;
}

export default Name;
